import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { ColorPickerModule } from "ngx-color-picker";
import { NgPipesModule } from "ngx-pipes";
import { TextMaskModule } from "angular2-text-mask";

import { ButtonModule } from "../button/index";
import { CameraModule } from "../camera/index";
import { DialogBaseModule } from "../dialog/dialog.base.module";
import { GenericModule } from "../generic/index";
import { GridModule } from "../grid/index";
import { IconModule } from "../icon/index";
import { ImageBaseModule } from "../image/image.base.module";
import { ListModule } from "../list/index";
import { LoadingModule } from "../loading/index";
import { PopoverModule } from "../popover/index";
import { SpinnerModule } from "../spinner/index";
import { ToastModule } from "../toast/index";

import { FormService } from "./form.service";
import { FormValidators } from "./form.validators";
import { FormComponent } from "./form.component";

// Components
import { InputComponent } from "./components/input/input.component";

import { InputButtonComponent } from "./components/partials/input-button/input-button.component";

import { InputCheckboxComponent } from "./components/inputs/checkbox/checkbox.component";
import { InputDateComponent } from "./components/inputs/date/date.component";
import { InputColorComponent } from "./components/inputs/color/color.component";
import { InputFileComponent } from "./components/inputs/file/file.component";
import { InputSelectComponent } from "./components/inputs/select/select.component";
import { InputTextComponent } from "./components/inputs/text/text.component";
import { InputTextareaComponent } from "./components/inputs/textarea/textarea.component";
import { InputTexteditorComponent } from "./components/inputs/texteditor/texteditor.component";
import { InputTimeComponent } from "./components/inputs/time/time.component";
import { InputTypeaheadComponent } from "./components/inputs/typeahead/typeahead.component";
import { InputNumberComponent } from "./components/inputs/number/number.component";
import { InputRadioComponent } from "./components/inputs/radio/radio.component";
import { InputRangeComponent } from "./components/inputs/range/range.component";

import { InputColorPickerModal } from "./components/inputs/color/color-picker.modal";
import { InputFileCropImageModal } from "./components/inputs/file/crop-image.modal";
import { InputFileTakePictureModal } from "./components/inputs/file/take-picture.modal";
import { InputSelectMultipleModal } from "./components/inputs/select/multiple.modal";

import { AutofocusDirective } from "./directives/autofocus.directive";

import { InputWysiwygComponent } from './components/inputs/wysiwyg/wysiwyg.component';

export { FormService } from "./form.service";

export * from "./form.interface";

export { FormData } from "./classes/data";
export { FormSchema } from "./classes/schema";

export { FormComponent } from "./form.component";
export { InputComponent } from "./components/input/input.component";

export { InputButtonComponent } from "./components/partials/input-button/input-button.component";

export { InputCheckboxComponent } from "./components/inputs/checkbox/checkbox.component";
export { InputColorComponent } from "./components/inputs/color/color.component";
export { InputDateComponent } from "./components/inputs/date/date.component";
export { InputFileComponent } from "./components/inputs/file/file.component";
export { InputSelectComponent } from "./components/inputs/select/select.component";
export { InputTextComponent } from "./components/inputs/text/text.component";
export { InputTextareaComponent } from "./components/inputs/textarea/textarea.component";
export { InputTexteditorComponent } from "./components/inputs/texteditor/texteditor.component";
export { InputTimeComponent } from "./components/inputs/time/time.component";
export { InputTypeaheadComponent } from "./components/inputs/typeahead/typeahead.component";
export { InputNumberComponent } from "./components/inputs/number/number.component";
export { InputRadioComponent } from "./components/inputs/radio/radio.component";
export { InputRangeComponent } from "./components/inputs/range/range.component";

export { InputColorPickerModal } from "./components/inputs/color/color-picker.modal";
export { InputFileCropImageModal } from "./components/inputs/file/crop-image.modal";
export { InputFileTakePictureModal } from "./components/inputs/file/take-picture.modal";
export { InputSelectMultipleModal } from "./components/inputs/select/multiple.modal";

export { AutofocusDirective } from "./directives/autofocus.directive";

export { InputWysiwygComponent } from './components/inputs/wysiwyg/wysiwyg.component';

@NgModule({
  declarations: [
    FormComponent,
    InputComponent,

    InputButtonComponent,

    InputCheckboxComponent,
    InputColorComponent,
    InputDateComponent,
    InputFileComponent,
    InputSelectComponent,
    InputTextComponent,
    InputTextareaComponent,
    InputTexteditorComponent,
    InputTimeComponent,
    InputTypeaheadComponent,
    InputNumberComponent,
    InputRadioComponent,
    InputRangeComponent,

    InputColorPickerModal,
    InputFileCropImageModal,
    InputFileTakePictureModal,
    InputSelectMultipleModal,

    AutofocusDirective,
    InputWysiwygComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    ColorPickerModule,
    NgPipesModule,
    TextMaskModule,

    ButtonModule,
    CameraModule,
    DialogBaseModule,
    GenericModule,
    GridModule,
    IconModule,
    ImageBaseModule,
    ListModule,
    LoadingModule,
    PopoverModule,
    SpinnerModule,
    ToastModule
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,

    FormComponent,
    AutofocusDirective,

    InputComponent
  ],
  entryComponents: [
    InputColorPickerModal,
    InputFileCropImageModal,
    InputFileTakePictureModal,
    InputSelectMultipleModal
  ],
  providers: [FormService, FormValidators],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FormModule {}
